import * as React from "react"

import { useStatefulFieldRemount } from "Catalog/shared/components/StatefulFieldRemountContext"
import DelayedScroller from "shared/components/DelayedScroller"
import useEditor from "shared/hooks/useEditor"

import { StyledDetails, Content, SplitHalf } from "./Styles"
import Topbar from "./Topbar"
import { TopbarIcon } from "./Topbar/Styles"

interface DetailsProps {
  children: React.ReactNode
  resourceId: number
  testId?: string
}

const Details = ({ children, resourceId, testId }: DetailsProps): JSX.Element => {
  const { remountKey } = useStatefulFieldRemount()
  const { catalog } = useEditor()
  const $scrollerInsideRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => void $scrollerInsideRef.current?.scroll({ top: 0, behavior: "smooth" }), [resourceId])

  return (
    <DelayedScroller ref={$scrollerInsideRef}>
      <StyledDetails
        data-testid={testId}
        key={[
          remountKey, // Re-mount when the catalog is updated externally (undo, redo, load)
          catalog.hrId, // Items from different catalogs can share the same id, so catalog id should be part of the key
          resourceId,
        ].join()}
      >
        <Content>{children}</Content>
      </StyledDetails>
    </DelayedScroller>
  )
}

export default {
  Main: Details,
  SplitHalf,
  Topbar,
  TopbarButton: TopbarIcon,
}
